module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_PlusInCircle_16"],"path":[{"$":{"d":"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4,9H9v3H7V9H4V7H7V4H9V7h3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_PlusInCircle_16.svg
// module id = P4m4
// module chunks = 1